module.exports = __webpack_public_path__ + "static/media/cc.3f2d4b50.svg";